import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {TrendingCutsGridComponent} from "../../components/trending-cuts-grid/trending-cuts-grid";
import {TrendingCutsListComponent} from "../../components/trending-cuts-list/trending-cuts-list";
import {TrendingCutsFavouritesComponent} from "../../components/trending-cuts-favourites/trending-cuts-favourites";

/**
 * Generated class for the TrendingCutsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-trending-cuts',
    templateUrl: 'trending-cuts.html',
})
export class TrendingCutsPage {

    grid = TrendingCutsGridComponent;
    list = TrendingCutsListComponent;
    favourites = TrendingCutsFavouritesComponent;

    trendingCutsTab: string = "grid";

    constructor(public navCtrl: NavController, public navParams: NavParams) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/trending-cuts/trending-cuts.ts